<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_i"></a><strong><em>The Nonverbal Advantage</em>     </strong><a id="page_ii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle.vue?72be922a